/* ============================================================
   pbg-scroll.js  (v3, July 16, 2026)
   Palm Beach Gems: vertical-scroll guard for horizontal
   carousels.

   HISTORY
   v1: document-level wheel guard forwarding vertical deltas over
       the tracks to the page scroller (fixes gesture latching).
   v2: dominance decided once per gesture, not per event (fixes
       mid-swipe stutter from stray horizontal frames).
   v3: listeners bound on the TRACKS instead of document, so the
       rest of the page keeps the browser's fast scrolling path
       (a document-level passive:false wheel listener forces
       every wheel on the page through the main thread), and
       forwarded deltas are batched per animation frame.

   Horizontal-dominant gestures pass through untouched, so the
   carousels still swipe natively.
   ============================================================ */
(function () {
  'use strict';

  /* RESOLVED (July 18, 2026): guard permanently off. The true
     root cause of the desktop stall was that the carousel tracks
     declared overflow-x auto without overflow-y, computing to
     two-axis scrollers that latched vertical wheel gestures and
     swallowed them. All PBG tracks now set overflow-y hidden, so
     native scrolling works everywhere and this guard is obsolete.
     Kept only as an emergency fallback: flip DISABLED to false to
     restore v3 forwarding. */
  var DISABLED = true;
  if (DISABLED) return;

  var TRACKS =
    '.pbg-categories__track, .pbg-arrivals__track, .pbg-half__viewport';
  var GESTURE_GAP = 300;

  function pageScroller(from) {
    var pw = from.closest('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight) {
      var o = getComputedStyle(pw).overflowY;
      if (o === 'auto' || o === 'scroll') return pw;
    }
    return document.scrollingElement || document.documentElement;
  }

  function normalizedDeltaY(e) {
    /* deltaMode: 0 pixels, 1 lines (Firefox), 2 pages */
    if (e.deltaMode === 1) return e.deltaY * 16;
    if (e.deltaMode === 2) return e.deltaY * window.innerHeight;
    return e.deltaY;
  }

  function bind(track) {
    if (track.dataset.pbgScrollGuard === '1') return;
    track.dataset.pbgScrollGuard = '1';

    var gestureAxis = null;
    var lastT = 0;
    var scroller = null;
    var pending = 0;
    var rafId = null;

    function flush() {
      rafId = null;
      if (scroller && pending) {
        scroller.scrollTop += pending;
        pending = 0;
      }
    }

    track.addEventListener(
      'wheel',
      function (e) {
        var now = e.timeStamp;
        if (now - lastT > GESTURE_GAP) {
          gestureAxis =
            Math.abs(e.deltaX) >= Math.abs(e.deltaY) ? 'x' : 'y';
          scroller = pageScroller(track); /* re-resolve per gesture */
        }
        lastT = now;

        if (gestureAxis === 'x') return; /* whole gesture to the carousel */
        e.preventDefault();
        pending += normalizedDeltaY(e);
        if (!rafId) rafId = requestAnimationFrame(flush);
      },
      { passive: false }
    );
  }

  function init(root) {
    var list = (root || document).querySelectorAll(TRACKS);
    for (var i = 0; i < list.length; i++) bind(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
